const axios = require('axios')
import { dbServices } from '@/services/db'
import { values } from 'lodash';
let reportUrl = '';
let generateReportUrl = '';
// let syncDicomUrl = '';
const API_URL = '/api';
console.log('process.env', process.env)
async function init() {
  const _res = await dbServices.get_setting()
  const setting = _res.data
  console.log('setting', setting)
  if(!setting.demo){
    reportUrl = setting.ishare_baseurl + '/nhia/newreport'
    generateReportUrl = setting.ishare_baseurl + '/nhia/generate-report'
    // syncDicomUrl = setting.ishare_baseurl + '/dicom/worklist'
  }else{
    reportUrl = process.env.VUE_APP_ISHARE_API_URL? process.env.VUE_APP_ISHARE_API_URL + '/nhia/newreport' : '/hub/api/nhia/newreport'
    generateReportUrl = process.env.VUE_APP_ISHARE_API_URL? process.env.VUE_APP_ISHARE_API_URL + '/nhia/generate-report' : '/hub/api/nhia/generate-report'
    // syncDicomUrl = process.env.VUE_APP_ISHARE_API_URL? process.env.VUE_APP_ISHARE_API_URL + '/dicom/worklist' : '/hub/api/dicom/worklist'
  }
}
init()
export const findingCodeOptions = [
  {
    value: 'A',
    text: '正常'
  },
  {
    value: 'B',
    text: '痔瘡'
  },
  {
    value: 'C',
    text: '瘜肉'
  },
  {
    value: 'D',
    text: '腫瘤'
  },
  {
    value: 'E',
    text: '發炎/潰瘍'
  },
  {
    value: 'F',
    text: '其他異常'
  },
  {
    value: 'G',
    text: '其他診斷'
  }
]
export const mappingValueB = [
  {"EVAS腸鏡finding": "Hemorrhoid", "Name": "Hemorrhoid", "Layer": "B", "parent": "B", "Value": "34", "ValueMapping": ""},
  {"EVAS腸鏡finding": "External hemorrhoid", "Name": "External hemorrhoid", "Layer": "B", "parent": "34", "Value": "576", "ValueMapping": "04"},
  {"EVAS腸鏡finding": "Mixed hemorrhoid", "Name": "Mixed hemorrhoid", "Layer": "B", "parent": "34", "Value": "577", "ValueMapping": "05"},
  {"EVAS腸鏡finding": "Internal hemorrhoid", "Name": "Internal hemorrhoid", "Layer": "B", "parent": "34", "Value": "575", "ValueMapping": "06"},
]
export const mappingValueC = [
  {"EVAS腸鏡finding": "Polyp", "Name": "Polyp", "Layer": "C", "parent": "C", "Value": "9", "ValueMapping": ""},
  {"EVAS腸鏡finding": "Tubular adenoma", "Name": "Tubular adenoma", "Layer": "C2", "parent": "C2", "Value": "543", "ValueMapping": "08"},
  {"EVAS腸鏡finding": "Tubulovillous adenoma", "Name": "Tubulovillous adenoma", "Layer": "C2", "parent": "C2", "Value": "544", "ValueMapping": "09"},
  {"EVAS腸鏡finding": "Villous adenoma", "Name": "Villous adenoma", "Layer": "C2", "parent": "C2", "Value": "545", "ValueMapping": "10"},
  {"EVAS腸鏡finding": "Sessile serrated adenoma", "Name": "Sessile serrated adenoma", "Layer": "C2", "parent": "C2", "Value": "546", "ValueMapping": "11"},
  {"EVAS腸鏡finding": "Traditional serrated adenoma", "Name": "Traditional serrated adenoma", "Layer": "C2", "parent": "C2", "Value": "547", "ValueMapping": "12"},
  {"EVAS腸鏡finding": "Post-treatment residual neoplasm", "Name": "Post-treatment residual neoplasm", "Layer": "C2", "parent": "C2", "Value": "664", "ValueMapping": "64"},
  {"EVAS腸鏡finding": "Hyperplastic polyp", "Name": "Hyperplastic polyp", "Layer": "C1", "parent": "C1", "Value": "540", "ValueMapping": "03"},
  {"EVAS腸鏡finding": "Inflammatory adenoma", "Name": "Inflammatory adenoma", "Layer": "C3", "parent": "C3", "Value": "548", "ValueMapping": "13"},
  {"EVAS腸鏡finding": "Juvenile polyp", "Name": "Juvenile polyp", "Layer": "C3", "parent": "C3", "Value": "542", "ValueMapping": "32"},
  {"EVAS腸鏡finding": "Colon polyposis", "Name": "其他瘜肉", "Layer": "C3", "parent": "C3", "Value": "642", "ValueMapping": "52"},
  {"EVAS腸鏡finding": "Colon polyposis, familial", "Name": "其他瘜肉", "Layer": "C3", "parent": "C3", "Value": "651", "ValueMapping": "51"},
  {"EVAS腸鏡finding": "Peutz-Jeghers syndrome", "Name": "其他瘜肉", "Layer": "C3", "parent": "C3", "Value": "541", "ValueMapping": "33"},
  {"EVAS腸鏡finding": "Inflammatory polyp", "Name": "其他瘜肉", "Layer": "C3", "parent": "C3", "Value": "661", "ValueMapping": "13"},
]
export const mappingValueD = [
  {"EVAS腸鏡finding": "Advanced colorectal cancer", "Name": "Advanced colorectal cancer", "Layer": "D1", "parent": "D1", "Value": "550", "ValueMapping": "15"},
  {"EVAS腸鏡finding": "Early colorectal cancer", "Name": "Early colorectal cancer", "Layer": "D1", "parent": "D1", "Value": "549", "ValueMapping": "14"},
  {"EVAS腸鏡finding": "Carcinoid tumor", "Name": "Carcinoid tumor", "Layer": "D2", "parent": "D2", "Value": "40", "ValueMapping": "36"},
  {"EVAS腸鏡finding": "Colon maltoma", "Name": "Colon maltoma", "Layer": "D2", "parent": "D2", "Value": "643", "ValueMapping": "53"},
  {"EVAS腸鏡finding": "Lipoma", "Name": "Lipoma", "Layer": "D2", "parent": "D2", "Value": "39", "ValueMapping": "35"},
  {"EVAS腸鏡finding": "Lymphangioma", "Name": "Lymphangioma", "Layer": "D2", "parent": "D2", "Value": "553", "ValueMapping": "34"},
  {"EVAS腸鏡finding": "Subepithelial tumor", "Name": "Subepithelial tumor", "Layer": "D2", "parent": "D2", "Value": "10", "ValueMapping": "44"},
  {"EVAS腸鏡finding": "Lateral spreading tumor", "Name": "Lateral spreading tumor", "Layer": "D", "parent": "D", "Value": "18", "ValueMapping": ""},
  {"EVAS腸鏡finding": "Flat tumor", "Name": "Flat tumor", "Layer": "D", "parent": "D", "Value": "19", "ValueMapping": ""},
  {"EVAS腸鏡finding": "Cancer", "Name": "Cancer", "Layer": "D", "parent": "D", "Value": "20", "ValueMapping": ""},
  {"EVAS腸鏡finding": "Polypoid tumor", "Name": "Polypoid tumor", "Layer": "D", "parent": "D", "Value": "57", "ValueMapping": ""},
  {"EVAS腸鏡finding": "GIST", "Name": "GIST", "Layer": "D", "parent": "D", "Value": "41", "ValueMapping": ""},
  {"EVAS腸鏡finding": "Metastatic tumor", "Name": "Metastatic tumor", "Layer": "D", "parent": "D", "Value": "42", "ValueMapping": ""},
  {"EVAS腸鏡finding": "Appendiceal tumor", "Name": "Appendiceal tumor", "Layer": "D", "parent": "D", "Value": "44", "ValueMapping": ""},
  {"EVAS腸鏡finding": "NET", "Name": "NET", "Layer": "D", "parent": "D", "Value": "45", "ValueMapping": ""},
  {"EVAS腸鏡finding": "Lymphoma", "Name": "Lymphoma", "Layer": "D", "parent": "D", "Value": "46", "ValueMapping": ""},
  {"EVAS腸鏡finding": "Hemangioma", "Name": "Hemangioma", "Layer": "D", "parent": "D", "Value": "47", "ValueMapping": ""},
  {"EVAS腸鏡finding": "Tumor", "Name": "Tumor", "Layer": "D2", "parent": "D2", "Value": "17", "ValueMapping": ""},
]
export const mappingValueE = [
  {"EVAS腸鏡finding": "Erosion", "Name": "Erosion", "Layer": "E", "parent": "E", "Value": "22", "ValueMapping": ""},
  {"EVAS腸鏡finding": "IBD", "Name": "IBD", "Layer": "E", "parent": "E", "Value": "24", "ValueMapping": ""},
  {"EVAS腸鏡finding": "Diverticulitis", "Name": "Diverticulitis", "Layer": "E", "parent": "E", "Value": "564", "ValueMapping": ""},
  {"EVAS腸鏡finding": "Ileitis", "Name": "Ileitis", "Layer": "E", "parent": "E", "Value": "50", "ValueMapping": ""},
  {"EVAS腸鏡finding": "Colitis", "Name": "Colitis", "Layer": "E", "parent": "E", "Value": "23", "ValueMapping": "16"},
  {"EVAS腸鏡finding": "Non-specific colitis", "Name": "Non-specific colitis", "Layer": "E", "parent": "E", "Value": "552", "ValueMapping": "17"},
  {"EVAS腸鏡finding": "Ischemic colitis", "Name": "Ischemic colitis", "Layer": "E", "parent": "E", "Value": "28", "ValueMapping": "18"},
  {"EVAS腸鏡finding": "Infectious colitis", "Name": "Infectious colitis", "Layer": "E", "parent": "E", "Value": "29", "ValueMapping": "19"},
  {"EVAS腸鏡finding": "Amoebic colitis", "Name": "Amebic colitis", "Layer": "E", "parent": "E", "Value": "31", "ValueMapping": "20"},
  {"EVAS腸鏡finding": "Ulcerative colitis", "Name": "Ulcerative colitis", "Layer": "E", "parent": "E", "Value": "25", "ValueMapping": "21"},
  {"EVAS腸鏡finding": "Radiation colitis", "Name": "Radiation colitis", "Layer": "E", "parent": "E", "Value": "32", "ValueMapping": "22"},
  {"EVAS腸鏡finding": "Pseudomembranous colitis", "Name": "Pseudo-membranous colitis", "Layer": "E", "parent": "E", "Value": "27", "ValueMapping": "23"},
  {"EVAS腸鏡finding": "Crohn's disease", "Name": "Crohn's disease", "Layer": "E", "parent": "E", "Value": "26", "ValueMapping": "27"},
  {"EVAS腸鏡finding": "Ulcer", "Name": "Colonic ulcer", "Layer": "E", "parent": "E", "Value": "21", "ValueMapping": "30"},
  {"EVAS腸鏡finding": "Bechet's disease", "Name": "Bechet's disease", "Layer": "E", "parent": "E", "Value": "554", "ValueMapping": "37"},
  {"EVAS腸鏡finding": "Proctitis", "Name": "Proctitis", "Layer": "E", "parent": "E", "Value": "33", "ValueMapping": "54"},
  {"EVAS腸鏡finding": "GVHD related colitis", "Name": "GVHD related colitis", "Layer": "E", "parent": "E", "Value": "638", "ValueMapping": "26"},
  {"EVAS腸鏡finding": "Hemorrhagic colitis", "Name": "Hemorrhagic colitis", "Layer": "E", "parent": "E", "Value": "644", "ValueMapping": "55"},
  {"EVAS腸鏡finding": "Drug-induced colitis", "Name": "Drug induce colitis", "Layer": "E", "parent": "E", "Value": "639", "ValueMapping": "24"},
  {"EVAS腸鏡finding": "Colitis aphthosa", "Name": "Colitis aphthosa", "Layer": "E", "parent": "E", "Value": "645", "ValueMapping": "56"},
  {"EVAS腸鏡finding": "Cytomegalovirus colitis", "Name": "Cytomegalovirus colitis", "Layer": "E", "parent": "E", "Value": "641", "ValueMapping": "25"},
]
export const mappingValueF = [
  {"EVAS腸鏡finding": "Diverticula", "Name": "Diverticula", "Layer": "F", "parent": "F", "Value": "36", "ValueMapping": ""},
  {"EVAS腸鏡finding": "Anastomosis", "Name": "Anastomosis", "Layer": "F", "parent": "F", "Value": "588", "ValueMapping": ""},
  {"EVAS腸鏡finding": "Diverticulum", "Name": "Diverticulum", "Layer": "F", "parent": "F", "Value": "35", "ValueMapping": "28"},
  {"EVAS腸鏡finding": "Diverticulosis", "Name": "Diverticulosis", "Layer": "F", "parent": "F", "Value": "37", "ValueMapping": "29"},
  {"EVAS腸鏡finding": "Melanosis coli", "Name": "Melanosis coli", "Layer": "F", "parent": "F", "Value": "49", "ValueMapping": "31"},
  {"EVAS腸鏡finding": "Xanthoma", "Name": "Xanthoma", "Layer": "F", "parent": "F", "Value": "38", "ValueMapping": "38"},
  {"EVAS腸鏡finding": "S/p partial colectomy", "Name": "S/p partial colectomy", "Layer": "F", "parent": "F", "Value": "555", "ValueMapping": "39"},
  {"EVAS腸鏡finding": "Left hemicolectomy", "Name": "Left hemicolectomy", "Layer": "F", "parent": "F", "Value": "596", "ValueMapping": "40"},
  {"EVAS腸鏡finding": "Right hemicolectomy", "Name": "Right hemicolectomy", "Layer": "F", "parent": "F", "Value": "595", "ValueMapping": "41"},
  {"EVAS腸鏡finding": "Situs inversus", "Name": "Situs inversus", "Layer": "F", "parent": "F", "Value": "556", "ValueMapping": "42"},
  {"EVAS腸鏡finding": "Colonic wall cyst", "Name": "Colonic wall cyst", "Layer": "F", "parent": "F", "Value": "557", "ValueMapping": "43"},
  {"EVAS腸鏡finding": "Lymphoid follicles", "Name": "Lymphoid follicles", "Layer": "F", "parent": "F", "Value": "558", "ValueMapping": "46"},
  {"EVAS腸鏡finding": "Operation scar", "Name": "Operation scar", "Layer": "F", "parent": "F", "Value": "559", "ValueMapping": "47"},
  {"EVAS腸鏡finding": "Suture granuloma", "Name": "Suture granuloma", "Layer": "F", "parent": "F", "Value": "560", "ValueMapping": "48"},
  {"EVAS腸鏡finding": "Petechia", "Name": "Petechia", "Layer": "F", "parent": "F", "Value": "561", "ValueMapping": "49"},
  {"EVAS腸鏡finding": "TB related lesion", "Name": "TB related lesion", "Layer": "F", "parent": "F", "Value": "551", "ValueMapping": "50"},
  {"EVAS腸鏡finding": "TB colitis", "Name": "TB colitis", "Layer": "F", "parent": "F", "Value": "30", "ValueMapping": "50"},
  {"EVAS腸鏡finding": "Angiodysplasia", "Name": "Angiodysplasia", "Layer": "F", "parent": "F", "Value": "640", "ValueMapping": "45"},
  {"EVAS腸鏡finding": "Amyloidosis", "Name": "Amyloidosis", "Layer": "F", "parent": "F", "Value": "646", "ValueMapping": "57"},
  {"EVAS腸鏡finding": "Mega colon", "Name": "Mega colon", "Layer": "F", "parent": "F", "Value": "647", "ValueMapping": "58"},
  {"EVAS腸鏡finding": "Rectal varices", "Name": "Rectal varices", "Layer": "F", "parent": "F", "Value": "648", "ValueMapping": "59"},
  {"EVAS腸鏡finding": "Mucosa prolapse", "Name": "Mucosa prolapse", "Layer": "F", "parent": "F", "Value": "649", "ValueMapping": "60"},
  {"EVAS腸鏡finding": "Intussusception", "Name": "Intussusception", "Layer": "F", "parent": "F", "Value": "650", "ValueMapping": "61"},
  {"EVAS腸鏡finding": "Colonic tuberculosis", "Name": "Colonic tuberculosis", "Layer": "F", "parent": "F", "Value": "662", "ValueMapping": "50"},
  {"EVAS腸鏡finding": "Colon fistula", "Name": "colon fistula", "Layer": "F", "parent": "F", "Value": "663", "ValueMapping": "62"},
  {"EVAS腸鏡finding": "Post-endoscopy treatment scar", "Name": "post endoscopy treatment scar", "Layer": "F", "parent": "F", "Value": "665", "ValueMapping": "63"},
  {"EVAS腸鏡finding": "Colonic stricture", "Name": "Colonic stricture", "Layer": "F", "parent": "F", "Value": "666", "ValueMapping": "65"}
]
export const mappingValueG = [
  {"EVAS腸鏡finding": "Active bleeding", "Name": "Active bleeding", "Layer": "G", "parent": "G", "Value": "586", "ValueMapping": "Active bleeding"},
  {"EVAS腸鏡finding": "Diverticular bleeding", "Name": "Diverticular bleeding", "Layer": "G", "parent": "G", "Value": "578", "ValueMapping": "Diverticular bleeding"},
  {"EVAS腸鏡finding": "Extraluminal impression", "Name": "Extraluminal impression", "Layer": "G", "parent": "G", "Value": "43", "ValueMapping": "Extraluminal impression"},
  {"EVAS腸鏡finding": "Foreign body", "Name": "Foreign body", "Layer": "G", "parent": "G", "Value": "51", "ValueMapping": "Foreign body"},
  {"EVAS腸鏡finding": "Fresh blood", "Name": "Fresh blood", "Layer": "G", "parent": "G", "Value": "585", "ValueMapping": "Fresh blood"},
  {"EVAS腸鏡finding": "GI bleeding", "Name": "GI bleeding", "Layer": "G", "parent": "G", "Value": "48", "ValueMapping": "GI bleeding "},
  {"EVAS腸鏡finding": "Hematin", "Name": "Hematin", "Layer": "G", "parent": "G", "Value": "583", "ValueMapping": "Hematin"},
  {"EVAS腸鏡finding": "Lower GI bleeding", "Name": "Lower GI bleeding", "Layer": "G", "parent": "G", "Value": "580", "ValueMapping": "Lower GI bleeding"},
  {"EVAS腸鏡finding": "Lymphoid hyperplasia", "Name": "Lymphoid hyperplasia", "Layer": "G", "parent": "G", "Value": "52", "ValueMapping": "Lymphoid hyperplasia"},
  {"EVAS腸鏡finding": "Occult bleeding", "Name": "Occult bleeding", "Layer": "G", "parent": "G", "Value": "581", "ValueMapping": "Occult bleeding"},
  {"EVAS腸鏡finding": "Scar", "Name": "Scar", "Layer": "G", "parent": "G", "Value": "587", "ValueMapping": "Scar"},
  {"EVAS腸鏡finding": "Stich", "Name": "Stich", "Layer": "G", "parent": "G", "Value": "594", "ValueMapping": "Stich"},
  {"EVAS腸鏡finding": "Stitches", "Name": "Stitches", "Layer": "G", "parent": "G", "Value": "597", "ValueMapping": "Stitches"},
  {"EVAS腸鏡finding": "Tarry stool", "Name": "Tarry stool", "Layer": "G", "parent": "G", "Value": "584", "ValueMapping": "Tarry stool"},
  {"EVAS腸鏡finding": "Unknown bleeder", "Name": "Unknown bleeder", "Layer": "G", "parent": "G", "Value": "582", "ValueMapping": "Unknown bleeder"},
  {"EVAS腸鏡finding": "Upper GI bleeding", "Name": "Upper GI bleeding", "Layer": "G", "parent": "G", "Value": "579", "ValueMapping": "Upper GI bleeding"},
]

export const lesionAOptions = [
  {
    value: '01',
    text: 'Negative finding'
  },
  {
    value: '02',
    text: 'Negative finding in the observable segments'
  },
  {
    value: '07',
    text: 'Poor preparation'
  }
]
export const lesionBOptions = [
  {
    value: '04',
    text: 'External hemorrhoids'
  },
  {
    value: '05',
    text: 'Mixed hemorrhoids'
  },
  {
    value: '06',
    text: 'Internal hemorrhoids'
  }
]
export const lesionCOptions = [
  {
    value: '1',
    text: '增生性瘜肉'
  },
  {
    value: '2',
    text: '腺瘤'
  },
  {
    value: '3',
    text: '其他瘜肉'
  }
]
export const lesionC1Options = [
  {
    value: '03',
    text: 'Hyperplastic polyp'
  }
]
export const lesionC2Options = [
  {
    value: '08',
    text: 'Tubular adenoma'
  },
  {
    value: '09',
    text: 'Tubulovillous adenoma'
  },
  {
    value: '10',
    text: 'Villous adenoma'
  },
  {
    value: '11',
    text: 'Sessile serrated adenoma'
  },
  {
    value: '12',
    text: 'Traditional serrated adenoma'
  },
  {
    value: '64',
    text: 'Post-treatment residual neoplasm'
  }
]
export const lesionC3Options = [
  {
    value: '13',
    text: 'Inflammatory polyp'
  },
  {
    value: '32',
    text: 'Juvenile polyp'
  },
  {
    value: '33',
    text: 'Peutz-Jeghers syndrome'
  },
  {
    value: '51',
    text: 'Colon polyposis, familiar'
  },
  {
    value: '52',
    text: 'Colon polyposis'
  }
]
export const lesionDOptions = [
  {
    value: '1',
    text: '疑似惡性腫瘤'
  },
  {
    value: '2',
    text: '其他腫瘤'
  }
]
export const lesionD1Options = [
  {
    value: '14',
    text: 'Early colorectal cancer'
  },
  {
    value: '15',
    text: 'Advanced colorectal cancer'
  }
]
export const lesionD2Options = [
  {
    value: '34',
    text: 'Lymphangioma'
  },
  {
    value: '35',
    text: 'Lipoma'
  },
  {
    value: '36',
    text: 'Carcinoid'
  },
  {
    value: '44',
    text: 'Submucosal tumor'
  },
  {
    value: '53',
    text: 'Colon MALToma'
  }
]
export const lesionEOptions = [
  {
    value: '16',
    text: 'Colitis'
  },
  {
    value: '17',
    text: 'Non-specific colitis'
  },
  {
    value: '18',
    text: 'Ischemic colitis'
  },
  {
    value: '19',
    text: 'Infectious colitis'
  },
  {
    value: '20',
    text: 'Amebic colitis'
  },
  {
    value: '21',
    text: 'Ulcerative colitis'
  },
  {
    value: '22',
    text: 'Radiation colitis'
  },
  {
    value: '23',
    text: 'Pseudo-membranous colitis'
  },
  {
    value: '24',
    text: 'Drug-induced colitis'
  },
  {
    value: '25',
    text: 'Cytomegalovirus colitis'
  },
  {
    value: '26',
    text: 'GVHD related colitis'
  },
  {
    value: '27',
    text: 'Crohn\'s disease'
  },
  {
    value: '30',
    text: 'Colonic ulcer'
  },
  {
    value: '37',
    text: 'Bechet\'s disease'
  },
  {
    value: '54',
    text: 'Proctitis'
  },
  {
    value: '55',
    text: 'Hemorrhagic colitis'
  },
  {
    value: '56',
    text: 'Colitis aphthosa'
  }
]
/**
 * "28=Colonic diverticulum
29=Colonic diverticulosis
31=Melanosis coli
38=Xanthoma
39=S/P partial colectomy
40=S/P left hemicolectomy
41=S/P right hemicolectomy
42=Situs inversus
43=Colonic wall cyst
45=Angiodysplasia (angiectasia)
46=Lymphoid follicles
47=Operation scar
48=Suture granuloma
49=Petechia
50=Colonic tuberculosis
57=Amyloidosis
58=Mega colon
59=Rectal varices
60=Mucosa prolapse
61=Intussusception
62=colon fistula
63=post endoscopy treatment scar
65= Colonic stricture"
 */
export const lesionFOptions = [
  {
    value: '28',
    text: 'Colonic diverticulum'
  },
  {
    value: '29',
    text: 'Colonic diverticulosis'
  },
  {
    value: '31',
    text: 'Melanosis coli'
  },
  {
    value: '38',
    text: 'Xanthoma'
  },
  {
    value: '39',
    text: 'S/P partial colectomy'
  },
  {
    value: '40',
    text: 'S/P left hemicolectomy'
  },
  {
    value: '41',
    text: 'S/P right hemicolectomy'
  },
  {
    value: '42',
    text: 'Situs inversus'
  },
  {
    value: '43',
    text: 'Colonic wall cyst'
  },
  {
    value: '45',
    text: 'Angiodysplasia (angiectasia)'
  },
  {
    value: '46',
    text: 'Lymphoid follicles'
  },
  {
    value: '47',
    text: 'Operation scar'
  },
  {
    value: '48',
    text: 'Suture granuloma'
  },
  {
    value: '49',
    text: 'Petechia'
  },
  {
    value: '50',
    text: 'Colonic tuberculosis'
  },
  {
    value: '57',
    text: 'Amyloidosis'
  },
  {
    value: '58',
    text: 'Mega colon'
  },
  {
    value: '59',
    text: 'Rectal varices'
  },
  {
    value: '60',
    text: 'Mucosa prolapse'
  },
  {
    value: '61',
    text: 'Intussusception'
  },
  {
    value: '62',
    text: 'Colon fistula'
  },
  {
    value: '63',
    text: 'Post endoscopy treatment scar'
  },
  {
    value: '65',
    text: 'Colonic stricture'
  },
]
export const locationOptions = [
  {
    value: '00',
    text: 'Terminal ileum'
  },
  {
    value: '01',
    text: 'Cecum'
  },
  {
    value: '02',
    text: 'Ascending colon'
  },
  {
    value: '03',
    text: 'Hepatic flexure'
  },
  {
    value: '04',
    text: 'Transverse colon'
  },
  {
    value: '05',
    text: 'Splenic flexure'
  },
  {
    value: '06',
    text: 'Descending colon'
  },
  {
    value: '07',
    text: 'Sigmoid colon'
  },
  {
    value: '08',
    text: 'Rectum'
  },
  {
    value: '09',
    text: 'Anastomosis'
  },
  {
    value: '10',
    text: 'Anus'
  },
  {
    value: '11',
    text: 'ICV'
  },
  {
    value: '12',
    text: 'Rectosigmoid junction(RSJ)'
  },
  {
    value: '99',
    text: '位置不明(與肛門口距離)'
  }
]
/**
 *00=Nil(未處置)
  01=S/p biopsy
  2a=S/p hot snare polypectomy
  2b= S/p cold snare polypectomy
  03=S/p EMR(Endoscopic mucosal resection)
  04=S/p ESD(Endoscopic submucosal dissection)
  05=S/p hemostasis
  06=S/p biopsy and removal
  07=S/p hot biopsy and removal
  08=S/p hemoclipping
  09=S/p tattooing
  10=S/p stenting
  11=S/p endolooping
  13= S/p EPMR(Endoscopic piecemeal mucosal resection)
  14= APC (argon plasma coagulation)
  99=Others(其他處置)
 */
export const samplingOptions = [
  {
    value: '00',
    text: 'Nil(未處置)'
  },
  {
    value: '01',
    text: 'S/p biopsy'
  },
  {
    value: '2a',
    text: 'S/p hot snare polypectomy'
  },
  {
    value: '2b',
    text: 'S/p cold snare polypectomy'
  },
  {
    value: '03',
    text: 'S/p EMR(Endoscopic mucosal resection)'
  },
  {
    value: '04',
    text: 'S/p ESD(Endoscopic submucosal dissection)'
  },
  {
    value: '05',
    text: 'S/p hemostasis'
  },
  {
    value: '06',
    text: 'S/p biopsy and removal'
  },
  {
    value: '07',
    text: 'S/p hot biopsy and removal'
  },
  {
    value: '08',
    text: 'S/p hemoclipping'
  },
  {
    value: '09',
    text: 'S/p tattooing'
  },
  {
    value: '10',
    text: 'S/p stenting'
  },
  {
    value: '11',
    text: 'S/p endolooping'
  },
  {
    value: '13',
    text: 'S/p EPMR(Endoscopic piecemeal mucosal resection)'
  },
  {
    value: '14',
    text: 'APC (argon plasma coagulation)'
  },
  {
    value: '99',
    text: 'Others(其他處置)'
  },
]
/**
 * "a=Use of anti-platelet or anti-coagulant
  b=Unexpected trouble during management (cardiopulmonary event, other complication, mechanical trouble, etc.)
  c=Difficulty in management (will resect at another session of colonoscopy)
  d=Difficulty in management (refer to other hospital)
  e=Difficulty in management (refer for surgery)
  f=Consent not obtained from the patient
  g=Patient’s schedule dose not match (will resect at another session of colonoscopy)
  z=Others"
 */
export const samrOptions = [
  {
    value: 'a',
    text: 'Use of anti-platelet or anti-coagulant'
  },
  {
    value: 'b',
    text: 'Unexpected trouble during management (cardiopulmonary event, other complication, mechanical trouble, etc.)'
  },
  {
    value: 'c',
    text: 'Difficulty in management (will resect at another session of colonoscopy)'
  },
  {
    value: 'd',
    text: 'Difficulty in management (refer to other hospital)'
  },
  {
    value: 'e',
    text: 'Difficulty in management (refer for surgery)'
  },
  {
    value: 'f',
    text: 'Consent not obtained from the patient'
  },
  {
    value: 'g',
    text: 'Patient’s schedule dose not match (will resect at another session of colonoscopy)'
  },
  {
    value: 'z',
    text: 'Others'
  },
]
export const polypOptions = [
  {
    value: '0',
    text: '無檢體'
  },
  {
    value: '1',
    text: '有檢體'
  }
]
export const indicationOptions = [
  {
    value: '1',
    text: '國民健康署糞便潛血檢查陽性'
  },
  {
    value: '2',
    text: '自費健康檢查'
  },
  {
    value: '9',
    text: '其他臨床目的施行之大腸鏡'
  }
]
export const indication1Options = [
  {
    value: '',
    text: '請選擇'
  },
  {
    value: 'a',
    text: '大腸癌家族史'
  },
  {
    value: 'b',
    text: '瘜肉切除後追蹤'
  },
  {
    value: 'c',
    text: '大腸癌術後追蹤'
  },
  {
    value: 'd',
    text: '大腸鏡併發症相關處理'
  },
  {
    value: 'e',
    text: '瘜肉或腫瘤切除'
  },
  {
    value: 'f',
    text: '發炎性腸道疾病追蹤'
  },
  {
    value: 'g',
    text: '術前評估'
  }
]
export const verify1Options = [
  {
    value: '1',
    text: '消化腸胃系內科'
  },
  {
    value: '2',
    text: '大腸直腸外科'
  },
  {
    value: '3',
    text: '一般外科'
  },
  {
    value: '9',
    text: '其他科別'
  }
]
export const insertionLevelMap = {
  '00': 'Terminal ileum',
  '01': 'Cecum',
  '02': 'Ascending colon',
  '03': 'Hepatic flexure',
  '04': 'Transverse colon',
  '05': 'Splenic flexure',
  '06': 'Descending colon',
  '07': 'Sigmoid colon',
  '08': 'Rectum',
  '09': 'Anastomosis',
  '10': 'Anus'
}
export const insertionLevelOptions =[
  {
    value: '00',
    text: 'Terminal ileum'
  },
  {
    value: '01',
    text: 'Cecum'
  },
  {
    value: '02',
    text: 'Ascending colon'
  },
  {
    value: '03',
    text: 'Hepatic flexure'
  },
  {
    value: '04',
    text: 'Transverse colon'
  },
  {
    value: '05',
    text: 'Splenic flexure'
  },
  {
    value: '06',
    text: 'Descending colon'
  },
  {
    value: '07',
    text: 'Sigmoid colon'
  },
  {
    value: '08',
    text: 'Rectum'
  },
  {
    value: '09',
    text: 'Anastomosis'
  },
  {
    value: '10',
    text: 'Anus'
  },
]
export const premedication1aOptions = [
  {
    value: '0',
    text: '無'
  },
  {
    value: '1',
    text: '有'
  }
]
export const premedication1bOptions = [
  {
    value: 'a',
    text: 'Glaucoma'
  },
  {
    value: 'b',
    text: 'BPH'
  },
  {
    value: 'c',
    text: '心跳過速'
  },
  {
    value: 'd',
    text: '過敏'
  },
  {
    value: 'z',
    text: '其他'
  }
]
export const premedication2bOptions = [
  {
    value: 'a',
    text: 'Midazolam(Dormicum)'
  },
  {
    value: 'b',
    text: 'Propofol'
  },
  {
    value: 'c',
    text: 'Meperidine(Demerol)'
  },
  {
    value: 'd',
    text: 'Fentanyl(含Alfentanyl)'
  },
  {
    value: 'e',
    text: '其他鎮靜麻醉藥物'
  }
]
export const colonPreparationOptions = [
  {
    value: '1',
    text: 'PEG-ELS類'
  },
  {
    value: '2',
    text: 'Phosphosoda類'
  },
  {
    value: '3',
    text: 'Magnesium citrate類'
  },
  {
    value: '4',
    text: 'Castor oil'
  },
  {
    value: '5',
    text: 'Dulcolax'
  },
  {
    value: '6',
    text: 'Enema'
  },
  {
    value: '9',
    text: '其他'
  }
]
export const preparationTimeOptions = [
  {
    value: '1',
    text: 'Morning single dose'
  },
  {
    value: '2',
    text: 'Evening single dose'
  },
  {
    value: '3',
    text: 'Split dose'
  }
]
export const preparationConditionOptions = [
  {
    value: '1',
    text: '良好Excellent'
  },
  {
    value: '2',
    text: '適當Good'
  },
  {
    value: '3',
    text: '尚可Fair'
  },
  {
    value: '4',
    text: '不良Poor'
  }
]
export const antiPlateletOptions = [
  {
    value: '0',
    text: '無'
  },
  {
    value: '1',
    text: '有'
  },
  {
    value: '2',
    text: '不知道(或不清楚吃何藥)'
  }
]
export const antiPlatelet1Options = [
  {
    value: 'a',
    text: 'Clopidogrel(Plavix)',
    id: '1'
  },
  {
    value: 'b',
    text: 'Asprin(Tapal /Bokey)',
    id: '2'
  },
  {
    value: 'c',
    text: 'Dipyridamole(Persantin)',
    id: '3'
  },
  {
    value: 'd',
    text: 'Warfarin(Coumadin)',
    id: '4'
  },
  {
    value: 'e',
    text: 'Dabigatran(Pradaxa)',
    id: '5'
  },
  {
    value: 'f',
    text: 'Apixaban(Eliquis)',
    id: '6'
  },
  {
    value: 'g',
    text: 'Rivaroxoban(Xarelto)',
    id: '7'
  },
  {
    value: 'h',
    text: 'Heparin',
    id: '8'
  }
]
export const complicationOptions = [
  {
    value: '0',
    text: 'Nil'
  },
  {
    value: '1',
    text: 'Significant bleeding'
  },
  {
    value: '2',
    text: 'Perforation'
  },
  {
    value: '3',
    text: 'Cardiopulmonary complication'
  },
  {
    value: '9',
    text: 'Other'
  }
]
export const detailBody = {
  detail_id: null,
  batch_id: 1,
  exam_id: 'EXAM001',
  hosp_id: 'H000001',
  idno: '123456789',
  patient_name: '病患一號',
  patient_birth: '1980-05-09',
  exam_date: '2018-10-15',
  patient_sex: '1',
  patient_age: 38,
  chartno: 'P0000000001',
  indication: '9',
  indication1: [],
  indication2: '',
  StartTime: '',
  EndTime:'',
  ReachCecumAt:'',
  insertion_level: 'd',
  premedication1a: '1',
  premedication1b: '',
  premedication2a: '',
  premedication2b: [],
  colon_preparation: [],
  colon_preparation1: '',
  preparation_time: '',
  preparation_condition: '',
  anti_platelet: '',
  anti_platelet1: '',
  days1: '',
  days2: '',
  days3: '',
  Complication: '',
  Complication1: '',
  verify: '醫生A',
  verify1: '1',
  specimen_count: 0,
  lesion_a: '',
}
export const lesionBody = {
  finding_code: 'A',
  location: '99',
  polyp: '00',
  sampling: '00',
  size: '',
  list_value: '',
  lesion_type: '1',
  lesion_subtype: '08',
  location1: '',
  sampling1: '',
  samr1: '',
  samr: ''
}
export const findingCodeMap = {
  '01': 'A',
  '02': 'A',
  '34': 'B',
  '575': 'B',
  '576': 'B',
  '577': 'B',
  '9': 'C',
  '540': 'C',
  '543': 'C',
  '544': 'C',
  '545': 'C',
  '546': 'C',
  '547': 'C',
  '548': 'C',
  '541': 'C',
  '542': 'C',
  '664': 'C',
  '642': 'C',
  '651': 'C',
  '661': 'C',
  '550': 'D',
  '549': 'D',
  '40': 'D',
  '643': 'D',
  '39': 'D',
  '553': 'D',
  '10': 'D',
  '18': 'D',
  '19': 'D',
  '20': 'D',
  '57': 'D',
  '41': 'D',
  '42': 'D',
  '44': 'D',
  '45': 'D',
  '46': 'D',
  '47': 'D',
  '17': 'D',
  '22': 'E',
  '24': 'E',
  '564': 'E',
  '50': 'E',
  '23': 'E',
  '552': 'E',
  '28': 'E',
  '29': 'E',
  '31': 'E',
  '25': 'E',
  '32': 'E',
  '27': 'E',
  '26': 'E',
  '21': 'E',
  '554': 'E',
  '33': 'E',
  '638': 'E',
  '639': 'E',
  '641': 'E',
  '644': 'E',
  '645': 'E',
  '36': 'F',
  '588': 'F',
  '35': 'F',
  '37': 'F',
  '49': 'F',
  '38': 'F',
  '555': 'F',
  '596': 'F',
  '595': 'F',
  '556': 'F',
  '557': 'F',
  '558': 'F',
  '559': 'F',
  '560': 'F',
  '561': 'F',
  '551': 'F',
  '30': 'F',
  '640': 'F',
  '646': 'F',
  '647': 'F',
  '648': 'F',
  '649': 'F',
  '650': 'F',
  '662': 'F',
  '663': 'F',
  '665': 'F',
  '666': 'F',
  '586': 'G',
  '578': 'G',
  '43': 'G',
  '51': 'G',
  '585': 'G',
  '48': 'G',
  '583': 'G',
  '580': 'G',
  '52': 'G',
  '581': 'G',
  '587': 'G',
  '594': 'G',
  '597': 'G',
  '584': 'G',
  '582': 'G',
  '579': 'G',
}
export const iShareHubRequest = ({reportType='upload', examId = [], validateOnly = false}) => {
  const defaultBody = {
    "unit": "1",
    "contact_name": "2",
    "contact_tel": "3",
    "contact_email": "4",
    "start_date": "2011-02-14",
    "end_date": "2035-02-14",
    "report_type": "delete",
    "format": "xml",
    "validate_only": false,
    "examId": '6'
  }
  return new Promise((resolve, reject) => {
    console.log('reportUrl', reportUrl)
    axios.post(reportUrl, {
      ...defaultBody,
      report_type: reportType,
      examId: examId.join(','),
      validate_only: validateOnly
    })
    .then(response => {
      resolve(response.data)
    })
    .catch(error => {
      reject(new Error(error.message||'HTTP_ERROR'))
    })
  })
}
export const getIshareData = (examId) => {
  return new Promise((resolve, reject) => {
    //nhia/getIshareData/3
    axios.get(`${API_URL}/nhia/getIshareData/${examId}`)
    .then(response => {
      resolve(response.data)
    })
    .catch(error => {
      reject(new Error(error.message||'HTTP_ERROR'))
    })
  })
}
export const queryIshareData = (examId) => {
  return new Promise((resolve, reject) => {
    //nhia/getIshareData/3
    axios.get(`${API_URL}/nhia/queryIshareData/${examId}`)
    .then(response => {
      resolve(response.data)
    })
    .catch(error => {
      reject(new Error(error.message||'HTTP_ERROR'))
    })
  })
}
export const saveIshareData = (detailData, lesionData, detailId = null, md5Content = '') => {
  // console.log('save ishare data', detailData, lesionData, detailId, md5Content)
  return new Promise((resolve, reject) => {
    axios.post(`${API_URL}/nhia/saveIshareData`, {
      detailData,
      lesionData,
      detailId,
      md5Content
    })
    .then(response => {
      resolve(response.data)
    })
    .catch(error => {
      reject(new Error(error.message||'HTTP_ERROR'))
    })
  })
}
export const generateReport = (examId) => {
  return new Promise((resolve, reject) => {
    axios.post(generateReportUrl, {
      exam_id: String(examId),
      batch_id: '',
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(new Error(error.message||'HTTP_ERROR'));
      });
  });
}
const handleAntiPlatelet1 = (data, skipSplit = false) => {
  if(skipSplit){
    return !data.Anti_platelet1 ? '': data.Anti_platelet1
  }
  let _tmp = !data.Anti_platelet1 ? [] : String(data.Anti_platelet1).split('')
  if(_tmp.length > 1){
    return _tmp.filter((item, index) => item !== '9').slice(0, 3)
  }
  return _tmp
}
export const handleIshareDetailData = (data, patient, examination, skipSplit = false) => {
  
  // console.log('handleIshareDetailData', typeof data.Patient_sex)
  // console.log(data, patient, examination)
  data.ColonPreparation = !data.ColonPreparation ? '' : String(data.ColonPreparation).replace('0', '')
  data.Anti_platelet1 = !data.Anti_platelet1 ? '' : String(data.Anti_platelet1).replace('9', '')
  // console.log('data.ColonPreparation', data.ColonPreparation.length)
  let _data = {
    ...detailBody,
      patient_sex: data.Patient_sex === '1' ? '1' : '2',
      patient_name: patient.name,
      patient_birth: patient.birthday.replace(/-/g, ''),
      patient_age: new Date(examination.date).getFullYear() - new Date(patient.birthday).getFullYear(),
      chartno: patient.no,
      exam_date: examination.date.replace(/-/g, ''),
      hosp_id: data.Hosp_ID,
      idno: patient.nationId || '',
      indication: data.Indication,
      indication1: skipSplit ? data.Indication1 : data.Indication1 ? data.Indication1.split('') || [] : [],
      indication2: data.Indication2,
      StartTime: data.StartTime,
      EndTime: data.EndTime,
      ReachCecumAt: data.ReachCecumAt,
      insertion_level: data.InsertionLevel.trim(),
      premedication1a: data.Premedication1a,
      premedication2a: data.Premedication2a,
      premedication1b: data.Premedication1b,
      premedication2b: skipSplit ? data.Premedication2b : data.Premedication2b ? data.Premedication2b.split('') || [] : [],
      anti_platelet: data.Anti_platelet,
      anti_platelet1: handleAntiPlatelet1(data, skipSplit),
      Complication: skipSplit ? data.Complication : data.Complication ? data.Complication.split('') || [] : [],
      Complication1: data.Complication1,
      colon_preparation: skipSplit ? data.ColonPreparation : data.ColonPreparation ? data.ColonPreparation.split('') || [] : [],
      colon_preparation1: data.ColonPreparation1,
      preparation_time: data.PreparationTime,
      days1: data.Days1,
      days2: data.Days2,
      days3: data.Days3,
      verify: data.Verify,
      verify1: data.Verify1,
      lesion_a: data.LesionA,
      specimen_count: data.specimen_count,
      exam_id: String(data.exam_id),
      preparation_condition: data.Condition1,
  }
  if(_data.anti_platelet1.length < 1){
    _data.days1 = ''
    _data.days2 = ''
    _data.days3 = ''
  }
  return _data;
}
export const handleIshareLesionData = (data = null, findings = [], skipSplit = false, lesionA = '') => {
  let findingEachSerial = 0
  let findingEachName = ''
  let _rtnData = []
  let _data = {
    lesion_type: lesionA,
    lesion_subtype: '',
    finding_code: 'A',
    location: [],
    polyp: '',
    size: '',
    location1: '',
    sampling: [],
    sampling1: '',
    samr: [],
    samr1: '',
    list_value: '',
    findingId: '',
    findingEachSerial: 0,
    findingEachName: 'Default',
  }
  if (!data){
    return [_data];
  }
  const splitDataLevel1 = data.split('@@')
  for(let index = 0; index < splitDataLevel1.length; index++){
    const splitDataLevel2 = splitDataLevel1[index].split('||')
    // console.log('splitDataLevel2', splitDataLevel2)
    const findingId = splitDataLevel2[0].trim()
    const findingCode = findingCodeMap[findingId] || 'G'
    const ff = findings.find(f => f.finding === findingId)
    if(findingEachName !== ff.name){
      findingEachName = ff.name
      findingEachSerial = 0
    }
    findingEachSerial += 1
    let lesionType = lesionA
    let lesionSubType = ''
    switch(findingCode){
      case 'A':
        lesionType = ''
        lesionSubType = ''
        break
      case 'B':
        lesionType = mappingValueB.find(v => v['Value'] === findingId)?.ValueMapping || ''
        lesionSubType = ''
        break
      case 'C':
        lesionType = mappingValueC.find(v => v['Value'] === findingId)?.Layer?.replace('C', '') || ''
        lesionSubType = mappingValueC.find(v => v['Value'] === findingId)?.ValueMapping || ''
        break
      case 'D':
        lesionType = mappingValueD.find(v => v['Value'] === findingId)?.Layer?.replace('D', '') || ''
        lesionSubType = mappingValueD.find(v => v['Value'] === findingId)?.ValueMapping || ''
        break
      case 'E':
        lesionType = mappingValueE.find(v => v['Value'] === findingId)?.ValueMapping || ''
        lesionSubType = ''
        break
      case 'F':
        lesionType = mappingValueF.find(v => v['Value'] === findingId)?.ValueMapping || ''
        lesionSubType = ''
        break
      case 'G':
        lesionType = mappingValueG.find(v => v['Value'] === findingId)?.ValueMapping || ''
        lesionSubType = ''
        break
    }
    _data = {
      lesion_type: lesionType,
      lesion_subtype: lesionSubType.trim(),
      finding_code: findingCode,
      location: skipSplit ? splitDataLevel2[1] : splitDataLevel2[1].match(/[\w]{2}/g)||[],
      polyp: splitDataLevel2[2],
      size: splitDataLevel2[4],
      location1: splitDataLevel2[5],
      sampling: skipSplit ? splitDataLevel2[6] : splitDataLevel2[6].match(/[\w]{2}/g)||[],
      sampling1: splitDataLevel2[7],
      samr: skipSplit ? splitDataLevel2[8] : splitDataLevel2[8].match(/[\w]{1}/g)||[],
      samr1: '',
      list_value: splitDataLevel2[9],
      findingId,
      findingEachSerial,
      findingEachName,
    }
    _rtnData.push(_data)
  }
  return _rtnData;
}
export const importIshareDataFromDB = (data) => {
  return {
    detail:{
      // detailBody 比對 data.detail 取出符合 detailBody 的 key
      ...Object.keys(detailBody).reduce((acc, key) => {
        if (data.detail[key]) {
          acc[key] = data.detail[key];
        }
        return acc;
      }, {}),
      patient_birth: data.detail.patient_birth.replace(/-/g, ''),
      exam_date: data.detail.exam_date.replace(/-/g, ''),
      indication1: data.detail.indication1 ? data.detail.indication1.match(/[\w]{1}/g)||[] : [],
      premedication2b: data.detail.premedication2b ? data.detail.premedication2b.match(/[\w]{1}/g)||[] : [],
      anti_platelet1: data.detail.anti_platelet1 ? data.detail.anti_platelet1.match(/[\w]{1}/g)||[] : [],
      Complication: data.detail.Complication ? data.detail.Complication.match(/[\w]{1}/g)||[] : [],
      colon_preparation: data.detail.colon_preparation ? data.detail.colon_preparation.match(/[\w]{1}/g)||[] : [],
    },
    lesion:data.lesion.map((item, index) => ({
      // lesionBody 比對 item 取出符合 lesionBody 的 key
      ...Object.keys(lesionBody).reduce((acc, key) => {
        if (item[key]) {
          acc[key] = item[key];
        }
        return acc;
      }, {}),
      location: item.location ? item.location.match(/[\w]{2}/g)||[] : [],
      sampling: item.sampling ? item.sampling.match(/[\w]{2}/g)||[] : [],
      samr: item.samr ? item.samr.match(/[\w]{1}/g)||[] : [],
    }))
  }
}
export const deleteIshareData = (detailId) => {
  return new Promise((resolve, reject) => {
    axios.post(`${API_URL}/nhia/deleteIshareData`, {
      detailId
    })
    .then(response => {
      resolve(response.data)
    })
    .catch(error => {
      reject(new Error(error || 'HTTP_ERROR'))
    })
  })
}
// export const syncDicom = (data) => {
//   return new Promise((resolve, reject) => {
//     axios.post(syncDicomUrl, {
//       data
//     })
//     .then(response => {
//       resolve(response.data)
//     })
//     .catch(error => {
//       reject(new Error(error || 'HTTP_ERROR'))
//     })
//   })
// }